import type {IssueEventInfo} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'

export function LockedText({info}: {info: IssueEventInfo}) {
  const {lockReason} = info
  return <>{lockReason ? `locked this conversation as ${lockReason}` : 'locked this conversation'}</>
}
